import { render, staticRenderFns } from "./LangDuJuZi.vue?vue&type=template&id=49144540&scoped=true"
import script from "./LangDuJuZi.vue?vue&type=script&lang=js"
export * from "./LangDuJuZi.vue?vue&type=script&lang=js"
import style0 from "./LangDuJuZi.vue?vue&type=style&index=0&id=49144540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49144540",
  null
  
)

export default component.exports